import groq from 'groq';
import { defaultLocale } from '@pkg/config/languages';

export const blockSignatureGeneratorFields = groq`
  signatureGeneratorFragment->{
    ...,
    },
    "defaultPronouns": *[_type == "fragments.signatureGenerator" && language == "${defaultLocale}"]{
      pronouns,
    }
`;
